export default {
    props: {
        titleText: {
            type: String,
            kComposite: 'title.text'
        }, 
        titleEncoded: {
            type: Boolean,
            kComposite: 'title.encoded'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-window-vue-wrapper/src/KendoWindow/Title.js